import {Trans} from 'react-i18next'
import messages from '../../../assets/messages'
import {getLevelColor, LEGEND_AGENT_LEVELS} from '../constants'
import {Legend, LegendItem, LegendTitle, Swatch} from './NetworkLegend.styled'

/**
 * Colour key for the per-level accent colours used across the offers tree: the master
 * Money Manager (level 0, red) followed by agent levels 1-4. Level 5 and deeper reuse
 * the level 1-4 colours in the same order, so only these five entries are listed.
 * Takes no props.
 */
export const NetworkLegend = () => (
  <Legend>
    <LegendTitle>
      <Trans {...messages.pammLegendTitle} />
    </LegendTitle>
    <LegendItem>
      <Swatch style={{backgroundColor: getLevelColor(0)}} />
      <Trans {...messages.pammLegendMasterMm} />
    </LegendItem>
    {LEGEND_AGENT_LEVELS.map((level) => (
      <LegendItem key={level}>
        <Swatch style={{backgroundColor: getLevelColor(level)}} />
        <Trans {...messages.pammLevelBadge} values={{level}} />
      </LegendItem>
    ))}
  </Legend>
)
